import i18n from '@core/plugins/i18n';
import { DEFAULT_LOCALE } from '@core/constants';
import { Serializable } from './serializable';

export class DynameatModel extends Serializable {
  constructor(guid = null) {
    super();
    this.guid = guid;
  }

  translateAttribute(attribute) {
    const localizedAttr = this[`${attribute}_${i18n.locale}`];
    if (!localizedAttr) return this[`${attribute}_${DEFAULT_LOCALE}`];
    return localizedAttr;
  }
}
